import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { AntdModule } from "../antd.module";
import { BackButtonComponent } from "./components/back-button/back-button.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { RolesDirective } from "./directives/roles/roles.directive";
import { TjBackButtonDirective } from "./directives/tj-back-button/tj-back-button.directive";
import { TjBasicInputComponent } from "./form/tj-basic-input/tj-basic-input.component";
import { TjSelectComponent } from "./form/tj-select/tj-select.component";
import { TjSwitchComponent } from "./form/tj-switch/tj-switch.component";
import { ToolsService } from "./services/tools/tools.service";
import { FooterComponent } from "./structure/footer/footer.component";
import { SidebarHeaderComponent } from "./structure/sidebar-header/sidebar-header.component";
import { DecimalToCommaPipe } from "./pipes/decimal-to-comma.pipe";
import { NzIconModule } from "ng-zorro-antd/icon";
import { HeaderComponent } from "./structure/header/header.component";
import { OrientacoesPopupComponent } from "./components/orientacoes-popup/orientacoes-popup.component";
import { OrientacoesAceiteComponent } from "./components/aceite-popup/orientacoes-aceite.component";
import { NzButtonModule } from "ng-zorro-antd/button";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

const directives = [TjBackButtonDirective, RolesDirective];

const importModules = [
    CommonModule,
    AntdModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NzIconModule,
    NzButtonModule,
];

const services = [ToolsService];

const sharedComponents = [
    BackButtonComponent,
    FooterComponent,
    SidebarHeaderComponent,
    TjBasicInputComponent,
    TjSelectComponent,
    TjSwitchComponent,
    LoaderComponent,
    HeaderComponent,
];

@NgModule({
    declarations: [...sharedComponents, ...directives, DecimalToCommaPipe, HeaderComponent, OrientacoesPopupComponent, OrientacoesAceiteComponent],
    imports: [...importModules],
    providers: [...services],
    exports: [...sharedComponents, ...directives, ...importModules, DecimalToCommaPipe, OrientacoesPopupComponent, OrientacoesAceiteComponent],
})
export class SharedModule { }
